<banner-outlet></banner-outlet>

<input type="checkbox" id="cl-nav-side" [(ngModel)]="navOpened" class="cl-nav-checkbox" checked="checked">
<nav class="cl-nav-side">
  <div class="cl-nav-backdrop" (click)="sideNavService.close()"></div>
  <div class="cl-nav-drawer">
    <div data-simplebar="data-simplebar">

      <div class="cl-nav-user">
        @if (portalIdp.getIdpName() !== 'castlabs') {
          <a>{{ userProfileService.email() }}</a>
        }
        @if (portalIdp.getIdpName() === 'castlabs') {
          <a
            [href]="(prod? 'https://account.castlabs.com/' : 'https://account.test.cs.castlabs.com/') + 'o/' + (organization())?.id ">{{ userProfileService.email() }}</a>
        }
      </div>

      <a class="cl-nav-organization" [routerLink]="[{outlets: { overlay: ['organizations'] }}]"
         queryParamsHandling="preserve" routerLinkActive="active">
        <label>Organization</label>
        <div class="cl-nav-organization-name">
          @if (organization(); as org) {
            <p>{{ org.name }}</p>
            <p>via {{ portalIdp.getIdpName() }} IDP</p>
          } @else {
            @if (organizations(); as orgs) {
              @if (orgs.length === 0) {
                <p>No organization</p>
              } @else {
                <p>Switch organization</p>
              }
            } @else {
              <p>Loading ...</p>
            }

          }

        </div>
      </a>

      @if (organization()) {
        @if (csNavEntries(); as navEntries) {
          <details class="cl-dropdown cl-dropdown-dark cl-dropdown-medium">
            <summary>
              <span>{{ NAV.CP.title }} </span>
              <p class="cl-subentry"> {{ NAV.CP.subtitle }}</p>
            </summary>
            @for (entry of navEntries; track entry.id) {
              <a class="cl-dropdown-item"
                 [href]="entry.url">
                <span>{{ entry.title }}</span>
                @if (entry.subtitle) {
                  <p class="cl-subentry">{{ entry.subtitle }}</p>
                }
              </a>
            }
          </details>
        }
      }
      <div class="cl-dropdown-arrow"></div>
      @if (organization(); as org) {
        @if ('contentplatform:repository:Query/Folder' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'files'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Files
            <p class="cl-nav-item-info"> Browse available files</p></a>
        }
        @if ('contentplatform:repository:Query/Search' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'search'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Search
            <p class="cl-nav-item-info"> Find files</p></a>
        }
        @if ('contentplatform:workflow:Mutation/StartWorkflowDefault' | isAllowed:'contentplatform:asset:input.content_identifier/isrc://': organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'audioorder'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Audio Order
            <p class="cl-nav-item-info"> Order encode via isrc</p></a>
        }
        <hr class="cl-nav-separator">
        @if ('contentplatform:workflow:PreviewEncode' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'previews'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Previews
            <p class="cl-nav-item-info"> Preview encodes for QA</p></a>
        }
        @if ('contentplatform:signiant:Query/Portals' | isAllowedAnywhere: organization()) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'signiant-portals'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Signiant Connectors
            <p class="cl-nav-item-info"> Signiant download portals</p></a>
        }
        @if (('contentplatform:repository:Query/DesktopHosts' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/EditingWorkspaces' | isAllowedAnywhere: organization())) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'crd'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Remote Desktop
            <p class="cl-nav-item-info"> Manage remote desktop sessions and editing workspaces</p></a>
        }
        @if (airlines() && airlines().length > 0) {
          <a [routerLink]="[{ outlets: { primary: ['o', org.id, 'workflows'], overlay: null } }]"
             [relativeTo]="null"
             routerLinkActive="active"
             class="cl-nav-item">Workflows
            <p class="cl-nav-item-info"> Monitor encoding and publication</p></a>
        }
        @if (portalIdp.getIdpName() == 'portal') {
          <a [routerLink]="[{ outlets: { primary: ['userprofile'], overlay: null } }]"
             class="cl-nav-item">User Profile
            <p class="cl-nav-item-info"> Set up MFA & change passwords</p></a>
        }
        @if (('contentplatform:repository:Query/Organization' | isAllowedAnywhere: organization()) ||
        ('contentplatform:signiant:Query/Portals' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/Search' | isAllowedAnywhere: organization()) ||
        ('contentplatform:workflow:PreviewEncode' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/DesktopHosts' | isAllowedAnywhere: organization()) ||
        ('contentplatform:repository:Query/EditingWorkspaces' | isAllowedAnywhere: organization()) ||
        ('contentplatform:workflow:Mutation/StartWorkflowDefault' | isAllowed:'contentplatform:asset:input.content_identifier/isrc://': organization()) ||
        airlines() && airlines().length > 0 ||
        portalIdp.getIdpName() == 'portal') {
          <hr class="cl-nav-separator">
        }
      }


      <a [routerLink]="[{outlets: {overlay: ['whats-new']}}]" [relativeTo]="null"
         queryParamsHandling="preserve" routerLinkActive="active" class="cl-nav-item">What's New
        @if (whatsNew.hasUnseen()) {
          <span class="cl-badge cl-badge-sm cl-color-sea">New</span>
        }
        <p class="cl-nav-item-info"> Recent platform changes</p></a>

      <a href="https://castlabs.atlassian.net/servicedesk/customer/portal/33" role="button" class="cl-nav-item"> Help
        Center </a>


      <!--
        Platform monitoring. Sits down here with the account-level items rather than up with the
        content navigation, because it is an operator view of the whole platform and not something you
        do to an organization's content. The crown marks it as an admin capability; the entry appears
        only where the policy grants it, so it is never a locked door.

        Shown whenever *any* of the user's organizations grants the action, and links to that one, so
        the entry does not appear and vanish as the user switches organization. Resolving which org
        that is cannot be a single policy check — see MonitoringAccessService.
      -->
      @if (monitoringAccess.organization(); as monitoringOrg) {
        <a [routerLink]="[{ outlets: { overlay: ['monitoring'] } }]"
           [relativeTo]="null"
           routerLinkActive="active"
           class="cl-nav-item"> Monitoring <i class="fas fa-crown" aria-hidden="true"></i>
          <p class="cl-nav-item-info"> Process failure rates and VTK jobs across all organizations</p></a>
      }

      <hr class="cl-nav-separator">
      <a href="#" (click)="doLogout()" role="button" class="cl-nav-item cl-faded"> Sign Out <i
        class="fas fa-sign-out-alt"></i></a>

      <div class="cl-spacing-medium"></div>
    </div>
  </div>
</nav>
<div class="cl-main">
  <router-outlet name="overlay" #overlay="outlet"></router-outlet>
  @if (!overlay.isActivated) {
    <!-- Airlines are the usual reason to be here, but a content supplier has none by design and only
         ever browses/uploads into its own PO directories -- so file-browsing access also admits. -->
    @if (contextService.organization() == null || contextService.airlines() && contextService.airlines().length > 0 || contextService.canBrowseFiles()) {
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    } @else {
      <app-logo-area></app-logo-area>
      <main>
        <app-headline-section [title]="'Not Authorized'"></app-headline-section>
        <section class="cl-section cl-section-regular">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <p class="alert cl-alert-info" role="alert">You are not authorized to access your company's Content
                  Platform UI. Please contact your administrator!</p>
              </div>

            </div>
          </div>

        </section>

      </main>

    }
  }
</div>

<app-auto-logout></app-auto-logout>

